import { apiFetch } from "./client";
import type { MealPlan, MealSlot, MealType } from "./types";
import { recommendationAcceptanceHeaders, type RecommendationAcceptanceMetadata } from "../recommendation-attribution";
import { clientLocalDateHeader } from "../dates";
export interface PlaceMealRequest {
  operationId: string;
  expectedPlanId: string | null;
  date: string;
  mealType: MealType;
  recipeId: string;
  proteinChoiceId?: string | null;
  servings: number;
  source?: "suggestion";
}
export interface PlaceMealResponse {
  mealPlan: MealPlan;
  slot: MealSlot;
  groceryListId: string;
}
export function placeMeal(
  request: PlaceMealRequest,
  attribution?: RecommendationAcceptanceMetadata,
  expectedActorUserId?: string,
  practicalFitRevision?: string,
): Promise<PlaceMealResponse> {
  return apiFetch("/meal-plans/place-meal", {
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      ...(practicalFitRevision ? { "X-Practical-Fit-Revision": practicalFitRevision } : {}),
      ...(attribution ? recommendationAcceptanceHeaders(attribution) : {}),
      ...(expectedActorUserId ? { "X-Expected-User-Id": expectedActorUserId } : {}),
      ...clientLocalDateHeader(),
    },
  });
}
